export default function ({ $axios, i18n }) {
  $axios.interceptors.request.use((config) => {
    const locale = i18n.locale
    if (locale) {
      $axios.setHeader('Content-Language', locale)
    }
    return config
  })
}
